var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vc-switch"},[_c('div',{staticClass:"switch-container",class:_vm.switchClasses,on:{"click":_vm.changeSwitch}},[_c('div',{staticClass:"switch",class:_vm.spinClasses}),_vm._v(" "),(_vm.isHasLabel)?_c('span',[_vm._v(_vm._s(_vm.label))]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60792a7c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vc-cat/vc-switch.vue
// module id = null
// module chunks = 